import {computed, inject, Injectable, signal} from '@angular/core';
import {environment} from '@epg-apps/cdh-environments';
import {HttpClient} from '@angular/common/http';
import {
  INIT_VERSIONINFO_STATE,
  VersionInfo,
  VersionInfoState,
} from '@epg-apps/cdh-models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VersionInfoService {
  private static readonly VERSIONINFO_CLOUDLINKMS_API =
    environment.cloudlinkMs + 'version/info-user';
  private readonly http = inject(HttpClient);

  private readonly versionInfoState = signal<VersionInfoState>({
    versionInfo: INIT_VERSIONINFO_STATE,
    isLoading: false,
  });

  versionInfo = computed(() => this.versionInfoState().versionInfo);

  public getVersionInfo(): Observable<VersionInfo> {
    const headerOptions = {
      params: {
        easypay_version: 'ignore',
        sofipam_version: '0.0.0',
      },
    };
    this.setIsLoading();
    return this.http.get<VersionInfo>(
      VersionInfoService.VERSIONINFO_CLOUDLINKMS_API,
      headerOptions,
    );
  }

  public setVersionInfo(versionInfo: VersionInfo): void {
    this.versionInfoState.update((state) => ({
      ...state,
      isLoading: false,
      versionInfo: versionInfo,
    }));
  }

  private setIsLoading(): void {
    this.versionInfoState.update((state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
  }
}
